import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import logo from '../Img/ProMed_Logo.png';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from "react-dropdown-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const RegisterForm = () => {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("registerData");
    return saved ? JSON.parse(saved) : {
      email: "",
      password: "",
      confirmPassword: "",
      title: "",
      name: "",
      profilePhoto: null,
      gender: "",
      designation: "",
      address: "",
      city: "",
      pincode: "",
      state: "",
      country: "",
      mobile: "",
      otp: ["", "", "", "", "", ""]
    };
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [timer, setTimer] = useState(59);
  const [resendAvailable, setResendAvailable] = useState(false);
  const otpRefs = useRef([]);
  const firstFieldRef = useRef(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [load, setLoad] = useState(false)
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isBackLoading, setIsBackLoading] = useState(false);



  useEffect(() => {
    if (firstFieldRef.current) firstFieldRef.current.focus();
  }, [step]);

  useEffect(() => {
    localStorage.setItem("registerData", JSON.stringify(formData));
  }, [formData]);

  const clearForm = () => {
    localStorage.removeItem("registerData");
    setFormData({
      email: "",
      password: "",
      confirmPassword: "",
      title: "",
      profilePhoto: null,
      name: "",
      gender: "",
      designation: "",
      address: "",
      city: "",
      pincode: "",
      state: "",
      country: "",
      mobile: "",
      otp: ["", "", "", "", "", ""]
    });
    setStep(0);
    console.log(formData);
  };

  useEffect(() => {
    if (step === 3 && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setResendAvailable(true);
    }
  }, [step, timer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleOTPChange = (index, value) => {
    const otp = [...formData.otp];
    otp[index] = value.slice(0, 1);
    setFormData({ ...formData, otp });
    if (value && index < otpRefs.current.length - 1) {
      otpRefs.current[index + 1].focus();
    }
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        [field]: file
      }));
    }
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;
  const validateStep = () => {
    const newErrors = {};
    if (step === 0) {
      if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Valid email is required";
      if (!formData.password || !passwordRegex.test(formData.password)) {
        newErrors.password =
          "Password must contain at least 6 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.";
      }
      if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    } else if (step === 1) {
      if (!formData.title) newErrors.title = "Title is required";
      if (!formData.name) newErrors.name = "Name is required";
      if (!formData.gender) newErrors.gender = "Gender is required";
      if (!formData.designation) newErrors.designation = "Designation is required";
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    } else if (step === 2) {
      if (!formData.address) newErrors.address = "Address is required";
      if (!formData.city) newErrors.city = "City is required";
      if (!formData.pincode || !/^[0-9]{5,6}$/.test(formData.pincode)) newErrors.pincode = "Valid pincode required";
      if (!formData.state) newErrors.state = "State is required";
      if (!formData.country) newErrors.country = "Country is required";
      if (!formData.mobile || !/^\d{12}$/.test(formData.mobile)) newErrors.mobile = "Valid 10-digit mobile number required";
    } else if (step === 3) {
      if (formData.otp.some(d => d === "")) newErrors.otp = "All OTP fields are required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = async () => {
    if (!validateStep()) return;
    setIsNextLoading(true);
    // Only check email duplication at Step 0
    if (step === 0) {
      try {
        const res = await fetch("https://backend.impactjournal.co.in/register/check-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email }),
        });

        const data = await res.json();

        if (data.exists) {
          setErrors(prev => ({ ...prev, email: "Email is already registered" }));
          return; // Stop here
        } else {
          setStep(prev => prev + 1);
        }
      } catch (err) {
        console.error("Email check failed", err);
        toast.error("Unable to validate email.");
      }
    } else {
      setStep(prev => prev + 1);
    }
    setIsNextLoading(false);
  };


  const prevStep = () => setStep((prev) => prev - 1);

  const renderError = (field) => errors[field] && <div className="form-register-error-impact">{errors[field]}</div>;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") nextStep();
  };

  const handleResend = async () => {
    try {
      const response = await fetch("https://backend.impactjournal.co.in/register/resend-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: formData.email })
      });

      const result = await response.json();
      if (response.ok) {
        setTimer(59);
        setResendAvailable(false);
        toast.success("OTP resent to your email.");
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error("Resend OTP failed", err);
      toast.error("Something went wrong.");
    }
  };

  const handleRegister = async () => {
    setIsRegistering(true);

    if (validateStep()) {
      try {
        const response = await fetch("https://backend.impactjournal.co.in/register", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
            title: formData.title,
            name: formData.name,
            gender: formData.gender,
            designation: formData.designation,
            address: formData.address,
            city: formData.city,
            pincode: formData.pincode,
            state: formData.state,
            country: formData.country,
            mobile: formData.mobile
          })
        });

        const result = await response.json();
        if (response.ok) {
          setStep(3);
          setTimer(59); // restart timer
          setResendAvailable(false);
        } else {
          toast.error(result.message);
        }
      } catch (err) {
        console.error("Registration failed", err);
        toast.error("Something went wrong.");
        setIsRegistering(false);
      } finally {
        setIsRegistering(false);
      }
    }
    setIsRegistering(false);
  };

  const handleVerifyOtp = async () => {
    setIsVerifying(true);
    const otpCode = formData.otp.join(""); // e.g. "123456"
    try {
      const response = await fetch("https://backend.impactjournal.co.in/register/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: formData.email,
          otp: otpCode
        })
      });

      const result = await response.json();
      if (response.ok) {
        toast.success("OTP verified successfully, User is Registered");
        clearForm();
        setTimeout(() => {
          navigate("/login-impact");
        }, 2000);
      }
      else {
        toast.error(result.message);
        setIsVerifying(false);
      }
    } catch (err) {
      console.error("OTP verification failed", err);
      toast.error("Something went wrong.");
      setIsVerifying(false);
    }
    setIsVerifying(false);
  };

  const testEmailSend = async () => {
    const response = await fetch("https://backend.impactjournal.co.in/register/test-mail");
    const data = await response.text();
    toast.success(data);
  };




  const titleOptions = [
    { label: "Mr", value: "Mr" },
    { label: "Ms", value: "Ms" },
    { label: "Mrs", value: "Mrs" },
    { label: "Dr", value: "Dr" },
    { label: "Prof", value: "Prof" }
  ];

  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
    { label: "Prefer not to say", value: "Prefer not to say" }
  ];

  const countryOptions = [
    { label: "Afghanistan", value: "Afghanistan" },
    { label: "Albania", value: "Albania" },
    { label: "Algeria", value: "Algeria" },
    { label: "Andorra", value: "Andorra" },
    { label: "Angola", value: "Angola" },
    { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
    { label: "Argentina", value: "Argentina" },
    { label: "Armenia", value: "Armenia" },
    { label: "Australia", value: "Australia" },
    { label: "Austria", value: "Austria" },
    { label: "Azerbaijan", value: "Azerbaijan" },
    { label: "Bahamas", value: "Bahamas" },
    { label: "Bahrain", value: "Bahrain" },
    { label: "Bangladesh", value: "Bangladesh" },
    { label: "Barbados", value: "Barbados" },
    { label: "Belarus", value: "Belarus" },
    { label: "Belgium", value: "Belgium" },
    { label: "Belize", value: "Belize" },
    { label: "Benin", value: "Benin" },
    { label: "Bhutan", value: "Bhutan" },
    { label: "Bolivia", value: "Bolivia" },
    { label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
    { label: "Botswana", value: "Botswana" },
    { label: "Brazil", value: "Brazil" },
    { label: "Brunei", value: "Brunei" },
    { label: "Bulgaria", value: "Bulgaria" },
    { label: "Burkina Faso", value: "Burkina Faso" },
    { label: "Burundi", value: "Burundi" },
    { label: "Cabo Verde", value: "Cabo Verde" },
    { label: "Cambodia", value: "Cambodia" },
    { label: "Cameroon", value: "Cameroon" },
    { label: "Canada", value: "Canada" },
    { label: "Central African Republic", value: "Central African Republic" },
    { label: "Chad", value: "Chad" },
    { label: "Chile", value: "Chile" },
    { label: "China", value: "China" },
    { label: "Colombia", value: "Colombia" },
    { label: "Comoros", value: "Comoros" },
    { label: "Congo (Brazzaville)", value: "Congo (Brazzaville)" },
    { label: "Congo (Kinshasa)", value: "Congo (Kinshasa)" },
    { label: "Costa Rica", value: "Costa Rica" },
    { label: "Croatia", value: "Croatia" },
    { label: "Cuba", value: "Cuba" },
    { label: "Cyprus", value: "Cyprus" },
    { label: "Czech Republic", value: "Czech Republic" },
    { label: "Denmark", value: "Denmark" },
    { label: "Djibouti", value: "Djibouti" },
    { label: "Dominica", value: "Dominica" },
    { label: "Dominican Republic", value: "Dominican Republic" },
    { label: "Ecuador", value: "Ecuador" },
    { label: "Egypt", value: "Egypt" },
    { label: "El Salvador", value: "El Salvador" },
    { label: "Equatorial Guinea", value: "Equatorial Guinea" },
    { label: "Eritrea", value: "Eritrea" },
    { label: "Estonia", value: "Estonia" },
    { label: "Eswatini", value: "Eswatini" },
    { label: "Ethiopia", value: "Ethiopia" },
    { label: "Fiji", value: "Fiji" },
    { label: "Finland", value: "Finland" },
    { label: "France", value: "France" },
    { label: "Gabon", value: "Gabon" },
    { label: "Gambia", value: "Gambia" },
    { label: "Georgia", value: "Georgia" },
    { label: "Germany", value: "Germany" },
    { label: "Ghana", value: "Ghana" },
    { label: "Greece", value: "Greece" },
    { label: "Grenada", value: "Grenada" },
    { label: "Guatemala", value: "Guatemala" },
    { label: "Guinea", value: "Guinea" },
    { label: "Guinea-Bissau", value: "Guinea-Bissau" },
    { label: "Guyana", value: "Guyana" },
    { label: "Haiti", value: "Haiti" },
    { label: "Honduras", value: "Honduras" },
    { label: "Hungary", value: "Hungary" },
    { label: "Iceland", value: "Iceland" },
    { label: "India", value: "India" },
    { label: "Indonesia", value: "Indonesia" },
    { label: "Iran", value: "Iran" },
    { label: "Iraq", value: "Iraq" },
    { label: "Ireland", value: "Ireland" },
    { label: "Israel", value: "Israel" },
    { label: "Italy", value: "Italy" },
    { label: "Jamaica", value: "Jamaica" },
    { label: "Japan", value: "Japan" },
    { label: "Jordan", value: "Jordan" },
    { label: "Kazakhstan", value: "Kazakhstan" },
    { label: "Kenya", value: "Kenya" },
    { label: "Kiribati", value: "Kiribati" },
    { label: "Korea, North", value: "Korea, North" },
    { label: "Korea, South", value: "Korea, South" },
    { label: "Kuwait", value: "Kuwait" },
    { label: "Kyrgyzstan", value: "Kyrgyzstan" },
    { label: "Laos", value: "Laos" },
    { label: "Latvia", value: "Latvia" },
    { label: "Lebanon", value: "Lebanon" },
    { label: "Lesotho", value: "Lesotho" },
    { label: "Liberia", value: "Liberia" },
    { label: "Libya", value: "Libya" },
    { label: "Liechtenstein", value: "Liechtenstein" },
    { label: "Lithuania", value: "Lithuania" },
    { label: "Luxembourg", value: "Luxembourg" },
    { label: "Madagascar", value: "Madagascar" },
    { label: "Malawi", value: "Malawi" },
    { label: "Malaysia", value: "Malaysia" },
    { label: "Maldives", value: "Maldives" },
    { label: "Mali", value: "Mali" },
    { label: "Malta", value: "Malta" },
    { label: "Marshall Islands", value: "Marshall Islands" },
    { label: "Mauritania", value: "Mauritania" },
    { label: "Mauritius", value: "Mauritius" },
    { label: "Mexico", value: "Mexico" },
    { label: "Micronesia", value: "Micronesia" },
    { label: "Moldova", value: "Moldova" },
    { label: "Monaco", value: "Monaco" },
    { label: "Mongolia", value: "Mongolia" },
    { label: "Montenegro", value: "Montenegro" },
    { label: "Morocco", value: "Morocco" },
    { label: "Mozambique", value: "Mozambique" },
    { label: "Myanmar", value: "Myanmar" },
    { label: "Namibia", value: "Namibia" },
    { label: "Nauru", value: "Nauru" },
    { label: "Nepal", value: "Nepal" },
    { label: "Netherlands", value: "Netherlands" },
    { label: "New Zealand", value: "New Zealand" },
    { label: "Nicaragua", value: "Nicaragua" },
    { label: "Niger", value: "Niger" },
    { label: "Nigeria", value: "Nigeria" },
    { label: "North Macedonia", value: "North Macedonia" },
    { label: "Norway", value: "Norway" },
    { label: "Oman", value: "Oman" },
    { label: "Pakistan", value: "Pakistan" },
    { label: "Palau", value: "Palau" },
    { label: "Panama", value: "Panama" },
    { label: "Papua New Guinea", value: "Papua New Guinea" },
    { label: "Paraguay", value: "Paraguay" },
    { label: "Peru", value: "Peru" },
    { label: "Philippines", value: "Philippines" },
    { label: "Poland", value: "Poland" },
    { label: "Portugal", value: "Portugal" },
    { label: "Qatar", value: "Qatar" },
    { label: "Romania", value: "Romania" },
    { label: "Russia", value: "Russia" },
    { label: "Rwanda", value: "Rwanda" },
    { label: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
    { label: "Saint Lucia", value: "Saint Lucia" },
    { label: "Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines" },
    { label: "Samoa", value: "Samoa" },
    { label: "San Marino", value: "San Marino" },
    { label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
    { label: "Saudi Arabia", value: "Saudi Arabia" },
    { label: "Senegal", value: "Senegal" },
    { label: "Serbia", value: "Serbia" },
    { label: "Seychelles", value: "Seychelles" },
    { label: "Sierra Leone", value: "Sierra Leone" },
    { label: "Singapore", value: "Singapore" },
    { label: "Slovakia", value: "Slovakia" },
    { label: "Slovenia", value: "Slovenia" },
    { label: "Solomon Islands", value: "Solomon Islands" },
    { label: "Somalia", value: "Somalia" },
    { label: "South Africa", value: "South Africa" },
    { label: "South Sudan", value: "South Sudan" },
    { label: "Spain", value: "Spain" },
    { label: "Sri Lanka", value: "Sri Lanka" },
    { label: "Sudan", value: "Sudan" },
    { label: "Suriname", value: "Suriname" },
    { label: "Sweden", value: "Sweden" },
    { label: "Switzerland", value: "Switzerland" },
    { label: "Syria", value: "Syria" },
    { label: "Taiwan", value: "Taiwan" },
    { label: "Tajikistan", value: "Tajikistan" },
    { label: "Tanzania", value: "Tanzania" },
    { label: "Thailand", value: "Thailand" },
    { label: "Timor-Leste", value: "Timor-Leste" },
    { label: "Togo", value: "Togo" },
    { label: "Tonga", value: "Tonga" },
    { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
    { label: "Tunisia", value: "Tunisia" },
    { label: "Turkey", value: "Turkey" },
    { label: "Turkmenistan", value: "Turkmenistan" },
    { label: "Tuvalu", value: "Tuvalu" },
    { label: "Uganda", value: "Uganda" },
    { label: "Ukraine", value: "Ukraine" },
    { label: "United Arab Emirates", value: "United Arab Emirates" },
    { label: "United Kingdom", value: "United Kingdom" },
    { label: "United States", value: "United States" },
    { label: "Uruguay", value: "Uruguay" },
    { label: "Uzbekistan", value: "Uzbekistan" },
    { label: "Vanuatu", value: "Vanuatu" },
    { label: "Vatican City", value: "Vatican City" },
    { label: "Venezuela", value: "Venezuela" },
    { label: "Vietnam", value: "Vietnam" },
    { label: "Yemen", value: "Yemen" },
    { label: "Zambia", value: "Zambia" },
    { label: "Zimbabwe", value: "Zimbabwe" }
  ];

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      email: "",
      password: "",
      confirmPassword: ""
    }));
  }, []);

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}

      <div className="register-main-pm">
        <div className="register-section-pm">
          <div className="register-container-left-pm">
            <img src={logo} alt="" />
            <h2>WELCOME TO INTERNATIONAL MULTIDISCIPLINARY PHARMACEUTICAL AND CLINICAL TRENDS</h2>
            <p>Your gateway to the latest research, reviews, and innovations in pharmaceutical and medical science. Register now to contribute, explore, and stay updated.</p>
          </div>
          <div className="form-register-wrapper-impact" onKeyDown={handleKeyDown}>
            <Stepper activeStep={step} className="form-register-stepper-impact">
              <Step label="Login Info" />
              <Step label="Personal Info" />
              <Step label="Contact Info" />
              <Step label="OTP" />
            </Stepper>

            {step === 0 && (
              <div className="form-register-step-impact">
                <h2>Create your account</h2>
                <div className="form-register-input-group-impact">
                  <input
                    ref={firstFieldRef}
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-register-input-impact"
                  />
                  {renderError("email")}
                </div>
                <div className="form-register-input-group-impact">
                  <div className="form-register-password-wrapper-impact">
                    <input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-register-input-impact"
                    />
                    <i
                      className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} form-register-eye-icon-impact`}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </div>
                  {renderError("password")}
                </div>
                <div className="form-register-input-group-impact">
                  <div className="form-register-password-wrapper-impact">
                    <input
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="form-register-input-impact"
                    />
                    <i
                      className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} form-register-eye-icon-impact`}
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    />
                  </div>
                  {renderError("confirmPassword")}
                </div>
              </div>
            )}

            {step === 1 && (
              <div className="form-register-step-impact">
                <div className="form-register-input-flex-impact">
                  {/* Title Select */}
                  <div className="form-register-input-group-impact form-select-impact form-register-title-select-impact">
                    <Select
                      options={titleOptions}
                      values={formData.title ? [{ label: formData.title, value: formData.title }] : []}
                      onChange={(selected) =>
                        setFormData((prev) => ({ ...prev, title: selected[0]?.value || "" }))
                      }
                      placeholder="Select Title"
                      className="form-register-dropdown-select"
                    />
                    {renderError("title")}
                  </div>

                  {/* Full Name Input */}
                  <div className="form-register-input-group-impact form-name-impact">
                    <input
                      ref={firstFieldRef}
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-register-input-impact"
                    />
                    {renderError("name")}
                  </div>
                </div>

                {/* Gender Select */}
                <div className="form-register-input-group-impact form-select-impact">
                  <Select
                    options={genderOptions}
                    values={formData.gender ? [{ label: formData.gender, value: formData.gender }] : []}
                    onChange={(selected) =>
                      setFormData((prev) => ({ ...prev, gender: selected[0]?.value || "" }))
                    }
                    placeholder="Select gender"
                    className="form-register-dropdown-select"
                  />
                  {renderError("gender")}
                </div>

                {/* Designation Input */}
                <div className="form-register-input-group-impact">
                  <input
                    name="designation"
                    placeholder="Designation"
                    value={formData.designation}
                    onChange={handleChange}
                    className="form-register-input-impact"
                  />
                  {renderError("designation")}
                </div>

                {/* Profile Photo Upload
                <div className="form-register-input-group-impact">
                  <label htmlFor="profilePhoto" className="form-register-label-impact">
                    Upload Profile Photo
                  </label>
                  <input
                    type="file"
                    id="profilePhoto"
                    name="profilePhoto"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'profilePhoto')}
                    className="form-register-input-impact"
                  />
                  {renderError("profilePhoto")}
                </div> */}
              </div>
            )}

            {step === 2 && (
              <div className="form-register-step-impact">
                <div className="form-register-input-group-impact">
                  <input ref={firstFieldRef} name="address" placeholder="Address" value={formData.address} onChange={handleChange} className="form-register-input-impact" />
                  {renderError("address")}
                </div>
                <div className="form-register-input-group-impact">
                  <input name="city" placeholder="City" value={formData.city} onChange={handleChange} className="form-register-input-impact" />
                  {renderError("city")}
                </div>
                <div className="form-register-input-group-impact">
                  <input name="pincode" placeholder="Pincode" value={formData.pincode} onChange={handleChange} className="form-register-input-impact" />
                  {renderError("pincode")}
                </div>
                <div className="form-register-input-group-impact">
                  <input
                    type="text"
                    name="state"
                    placeholder="State"
                    value={formData.state}
                    onChange={handleChange}
                    className="form-register-input-impact"
                  />
                  {renderError("state")}
                </div>

                <div className="form-register-input-group-impact form-select-impact">
                  <Select
                    options={countryOptions}
                    values={formData.country ? [{ label: formData.country, value: formData.country }] : []}
                    onChange={(selected) =>
                      setFormData((prev) => ({ ...prev, country: selected[0]?.value || "" }))
                    }
                    placeholder="Select country"
                    className="form-register-dropdown-select"
                  />
                  {renderError("country")}
                </div>
                <div className="form-register-input-group-impact">
                  <PhoneInput
                    country={'in'} // default country
                    value={formData.mobile}
                    onChange={(mobile) => setFormData({ ...formData, mobile })}
                    inputClass="form-register-input-impact"
                    inputProps={{
                      name: 'mobile',
                      required: true,
                      id: 'mobile'
                    }}
                  />

                  {renderError("mobile")}
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="form-register-step-impact">
                <p className="otp-instruction">OTP sent to <br /><strong>{formData.email}</strong></p>
                <div className="form-register-otp-wrapper-impact">
                  {formData.otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      value={digit}
                      onChange={(e) => handleOTPChange(index, e.target.value)}
                      className="form-register-otp-input-impact"
                      maxLength={1}
                      ref={(el) => otpRefs.current[index] = el}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !digit && index > 0) {
                          otpRefs.current[index - 1].focus();
                        }
                      }}
                    />
                  ))}
                  {renderError("otp")}
                </div>
                <div className="otp-resend-section">
                  {resendAvailable ? (
                    <button
                      onClick={handleResend}
                      className="form-resend-code-btn"
                      disabled={isResending}
                    >
                      {isResending ? <span className="spinner" /> : "Resend Code?"}
                    </button>
                  ) : (
                    <p className="otp-timer">Resend available in 0:{timer < 10 ? `0${timer}` : timer}</p>
                  )}
                </div>
              </div>
            )}

            <div className="form-register-navigation-impact">
              {step > 0 && <button onClick={prevStep} className="form-register-btn-impact form-register-btn-back-impact">Back</button>}
              {step < 3 ? (
                <button
                  onClick={step === 2 ? handleRegister : nextStep}
                  className="form-register-btn-impact form-register-btn-next-impact"
                  disabled={
                    (step === 2 && isRegistering) ||
                    isNextLoading
                  }
                >
                  {step === 2
                    ? (isRegistering ? <span className="spinner" /> : "Register")
                    : (isNextLoading ? <span className="spinner" /> : "Next")
                  }
                </button>
              ) : (
                <button
                  onClick={handleVerifyOtp}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                  disabled={isVerifying}
                >
                  {isVerifying ? <span className="spinner" /> : "Verify OTP"}
                </button>
              )}
            </div>
            <div className="register-form-footer">
              Already have an account?{" "}
              <span onClick={() => navigate("/login-impact")} className="login-link-pm">
                Login
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterForm;